var $schema = "http://json-schema.org/draft-07/schema";
var $id = "EntityEnvelope";
var description = "The envelope skeleton parts of an entity - whatever is necessary to be able to give it a ref and pass to further validation / policy checking.";
var examples = [
	{
		apiVersion: "backstage.io/v1alpha1",
		kind: "Component",
		metadata: {
			name: "LoremService"
		}
	}
];
var type = "object";
var required = [
	"apiVersion",
	"kind",
	"metadata"
];
var additionalProperties = true;
var properties = {
	apiVersion: {
		type: "string",
		description: "The version of specification format for this particular entity that this is written against.",
		minLength: 1,
		examples: [
			"backstage.io/v1alpha1",
			"my-company.net/v1",
			"1.0"
		]
	},
	kind: {
		type: "string",
		description: "The high level entity type being described.",
		minLength: 1,
		examples: [
			"API",
			"Component",
			"Domain",
			"Group",
			"Location",
			"Resource",
			"System",
			"Template",
			"User"
		]
	},
	metadata: {
		type: "object",
		required: [
			"name"
		],
		additionalProperties: true,
		properties: {
			name: {
				type: "string",
				description: "The name of the entity. Must be unique within the catalog at any given point in time, for any given namespace + kind pair.",
				examples: [
					"metadata-proxy"
				],
				minLength: 1
			},
			namespace: {
				type: "string",
				description: "The namespace that the entity belongs to.",
				"default": "default",
				examples: [
					"default",
					"admin"
				],
				minLength: 1
			}
		}
	}
};
var entityEnvelopeSchema = {
	$schema: $schema,
	$id: $id,
	description: description,
	examples: examples,
	type: type,
	required: required,
	additionalProperties: additionalProperties,
	properties: properties
};

export { $id, $schema, additionalProperties, entityEnvelopeSchema as default, description, examples, properties, required, type };
//# sourceMappingURL=EntityEnvelope.schema.json.esm.js.map
